module.exports = __webpack_public_path__ + "static/media/rocket-icon.a0b9ea98.svg";